import { gql } from 'graphql.macro';

export const CreateCategory = gql`
    mutation CreateNearMissCategory($request: InsertNearMissCategoryRequestModelInput){
        createNearMissCategory(request: $request)
    }
`;